import React from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import validator from 'validator';
import Box from '@material-ui/core/Box';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { Button, Typography } from '@material-ui/core';
import { Input } from 'components/FormInputs';
import { useFormik } from 'components/shared/Formik';

const LoginStepTwoConfirmEmail = ({ onSubmit, inProgress, error, originalEmail }) => {
  const intl = useIntl();
  const formik = useFormik({
    initialValues: {
      confirmEmail: '',
    },
    validate: (values) => {
      const errors = {};

      if (!values.confirmEmail) {
        errors.confirmEmail = intl.formatMessage({
          id: 'welcome.confirmEmailEmpty',
          defaultMessage: 'Please fill in your email address',
        });
      } else if (!validator.isEmail(values.confirmEmail)) {
        errors.confirmEmail = 'Fyll i en riktig e-postadress';
      } else if (values.confirmEmail.toLowerCase() !== originalEmail.toLowerCase()) {
        errors.confirmEmail = intl.formatMessage({
          id: 'welcome.confirmEmailMismatch',
          defaultMessage: 'Email addresses do not match',
        });
      }

      return errors;
    },
    validateOnBlur: true,
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  const { handleChange, handleSubmit, values, errors, isValid, handleBlur, setErrors } = formik;

  React.useEffect(() => {
    if (!isEmpty(error)) {
      setErrors({ confirmEmail: 'Fyll i en riktig e-postadress' });
    }
  }, [error]);

  return (
    <div>
      <Typography variant="h6">
        <FormattedMessage id="welcome.confirmEmailHeader" defaultMessage="Confirm your email" />
      </Typography>
      <form onSubmit={handleSubmit} noValidate>
        <Input
          label={
            <FormattedMessage
              id="welcome.confirmEmailLabel"
              defaultMessage="Enter your email again"
            />
          }
          placeholder={intl.formatMessage({
            id: 'Email',
            defaultMessage: 'Email',
          })}
          name="confirmEmail"
          type="email"
          InputLabelProps={{
            shrink: true,
          }}
          autoFocus
          errors={errors}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.confirmEmail}
        />
        <Box mt={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            disabled={inProgress || !isValid}
            type="submit"
          >
            {inProgress ? (
              <FormattedMessage id="welcome.loading" defaultMessage="Loading" />
            ) : (
              <FormattedMessage id="welcome.continue" defaultMessage="Continue" />
            )}
            <ChevronRight />
          </Button>
        </Box>
      </form>
    </div>
  );
};

LoginStepTwoConfirmEmail.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  inProgress: PropTypes.bool.isRequired,
  error: PropTypes.shape({}),
  originalEmail: PropTypes.string.isRequired,
};

export default LoginStepTwoConfirmEmail;
